import React from 'react';
import './ChapterNavigation.css';

export default function ChapterNavigation({
  chapters,
  currentChapter,
  onChapterClick,
  answeredQuestions,
  visitedChapters = new Set()
}) {
  // Finde heraus, welches Kapitel gerade aktiv ist
  const getCurrentChapterIndex = () => {
    if (!currentChapter) return -1;
    return chapters.findIndex(ch => ch.title === currentChapter);
  };

  // Prüfe ob ein Kapitel mindestens eine beantwortete Frage hat
  const hasAnsweredQuestion = (chapter) => {
    if (!chapter.questions || !answeredQuestions) return false;
    return chapter.questions.some(q => answeredQuestions.has(q.key));
  };

  const currentIndex = getCurrentChapterIndex();

  return (
    <div className="chapter-navigation">
      <div className="chapter-nav-inner">
        {chapters.map((chapter, index) => {
          const isActive = index === currentIndex;
          const hasAnswers = hasAnsweredQuestion(chapter);
          const isVisited = visitedChapters.has(index);
          const isClickable = isVisited; // Nur besuchte Kapitel sind klickbar
          const chapterNumber = index + 1;

          return (
            <div
              key={chapter.title}
              className={`chapter-nav-item ${isActive ? 'active' : ''} ${isClickable ? 'clickable' : 'disabled'} ${isVisited ? 'visited' : ''}`}
              onClick={() => isClickable && onChapterClick(index)}
              title={isClickable ? chapter.title : 'Kapitel noch nicht erreicht'}
            >
              {/* Verbindungslinie */}
              {index < chapters.length - 1 && (
                <div className={`chapter-connector ${isVisited ? 'visited' : ''}`} />
              )}

              {/* Punkt/Kreis */}
              <div className="chapter-circle">
                {chapterNumber}
              </div>

              {/* Kapitel-Label (nur bei hover sichtbar) */}
              <div className="chapter-label">
                {chapter.title.split(':')[0]}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
